import React from 'react';

const UploadTemplateModal = ({ showModal, closeModal, handleSubmit, handleFileChange, apiUrl }) => {
  if (!showModal) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 bg-opacity-50 text-white">
      <div className="bg-primary-dark w-full max-w-sm rounded-lg p-6">
        <h1 className="mb-4 text-center text-2xl font-semibold">Template</h1>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              htmlFor="file"
              className="mb-2 block text-white"
            >
              Selecciona un archivo:
            </label>
            <input
              id="file"
              type="file"
              onChange={handleFileChange}
              accept=".docx, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              className="w-full rounded-lg border border-gray-300 bg-black p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <span>
              Ejemplo del documento a cargar:{' '}
              <a
                href={apiUrl + '/api/documentos/download-template/'}
                className="text-blue-600"
              >
                template.docx
              </a>
            </span>
          </div>
          <div className="flex items-center justify-between gap-2">
            <button
              type="submit"
              className="w-full rounded-lg bg-blue-500 py-2 text-white transition duration-200 hover:bg-blue-600"
            >
              Subir
            </button>
            <button
              className="w-full rounded-lg bg-red-500 py-2 text-white transition duration-200 hover:bg-red-600"
              onClick={closeModal}
            >
              Cerrar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UploadTemplateModal;
